
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/j/[jobslug]",
      function () {
        return require("private-next-pages/j/[jobslug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/j/[jobslug]"])
      });
    }
  